import { useSearchParams } from 'react-router-dom';

import { Layout } from './Layout.tsx';

const ERROR_MESSAGES: Record<string, string> = {
  missing_code: 'Sign-in returned no code. Please try again.',
  invalid_state: 'Sign-in state mismatch. Please try again.',
  auth_failed: 'Sign-in could not be completed. Please try again.',
};

export function Login() {
  const [params] = useSearchParams();
  const errorParam = params.get('error');
  const message = errorParam
    ? (ERROR_MESSAGES[errorParam] ?? errorParam)
    : null;

  const apiUrl = import.meta.env.VITE_API_URL ?? 'https://api.technicalaccounting.net';
  const signInUrl = `${apiUrl}/v1/auth/sign-in`;

  return (
    <Layout title="Sign in — Technical Accounting">
      <h1 className="view-h1">Sign in</h1>
      {message ? <p style={{ color: '#c0392b' }}>{message}</p> : null}
      <p>
        <a href={signInUrl} className="btn">Continue with WorkOS</a>
      </p>
    </Layout>
  );
}
